module.exports = __webpack_public_path__ + "0af5d249/img/share-action-icon.9c12578c.svg";